import React, { ReactElement } from "react";
import { createPortal } from "react-dom";
import { IconX } from "@tabler/icons-react";
import ButtonStyled from "./ButtonStyled";
import { useLanguage } from "../../context/LanguageContext";

type Props = {
  onClose: React.MouseEventHandler<HTMLButtonElement>;
  title: string;
  children: React.ReactNode;
  actionButtonText?: string | React.ReactElement | false | undefined;
  open: boolean;
  actionButtonOnClick?: React.MouseEventHandler<HTMLButtonElement>;
  cancelButtonOnClick?: React.MouseEventHandler<HTMLButtonElement>;
  actionButtonExtraClasses?: string | undefined;
  actionButtonProps?: React.ComponentProps<"button">;
  actionButtonIcon?: ReactElement | false | undefined;
  closeButtonText?: string;
  hideFooter?: boolean;
  isPending?: boolean;
  showFooter?: boolean;
  classWidth?: string;
};

const NewCommonModal = (props: Props) => {
  const { language } = useLanguage();
  if (!props.open) return null;

  return createPortal(
    <div 
      dir={language === "ar" ? "rtl" : "ltr"}
      className="fixed top-0 left-0 w-full h-screen bg-black/60 z-[9999] flex items-center justify-end p-4 overflow-y-auto"
    >
      <div
        className={`rounded-2xl ${props.classWidth ?? "xl:w-7/12 lg:w-8/12 w-11/12"}  relative`}
      >
        <div className="flex items-center">
          <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4   w-full rounded-tl-3xl rounded-tr-[63px] ">
            <h1 className="text-2xl">{props.title}</h1>
          </div>
          <div className="relative ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={38}
              height={37}
              viewBox="0 0 38 37"
              fill="none"
              className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
            >
              <path
                d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
                fill="#F7F6F2"
              />
            </svg>

            <button
              onClick={props.onClose}
              className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
            >
              <IconX size={20} />
            </button>
          </div>
        </div>
        {props.children}
        {!props.hideFooter && (
          <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px] ">
            {/* <button
              className="border border-[#D8D8D8]  bg-transparent flex items-center rounded-full p-2 px-4 space-x-1 cursor-pointer text-base font-medium "
              onClick={props.cancelButtonOnClick ?? props.onClose}
            >
              {props.closeButtonText}
            </button> */}
            {props?.actionButtonText && (
              <ButtonStyled
                value={props?.actionButtonText}
                onClick={props.actionButtonOnClick}
                extraClasses={props.actionButtonExtraClasses}
                extraProps={props.actionButtonProps}
                icon={props.actionButtonIcon}
                isPending={props?.isPending}
              />
            )}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default NewCommonModal;